// Theo doi moc "hoat dong gan nhat" dung chung giua axios interceptor (tinh
// ca cac request chay nen, vi du dang tai/tai file) va IdleLogout.vue (dem
// gio truc tiep tu chuot/ban phim) - ca hai deu duoc coi la "hoat dong" de
// khong tu dang xuat giua luc dang tai/tai file chay nhieu gio ma khong ai
// dong vao chuot.
const activityTracker = {
  lastActivityAt: Date.now(),
  touch() {
    this.lastActivityAt = Date.now()
  },
}

export default activityTracker
